module.exports = __webpack_public_path__ + "img/thumbs-up-on.8e001827.svg";